import React, { useCallback, useEffect, useState } from "react";
import LayoutPage from "../Layout";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { toast } from "react-toastify";

function EditNoti() {
  const navigate = useNavigate();
  const [userid, setUserIds] = useState([]);
  const [notiData, setNotiData] = useState();
  const [loading, setLoading] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [options, setOptions] = useState([]);
  const [title1, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [data, setData] = useState();
  const params = useParams();

  const [initialValues, setInitialValues] = useState({
    title: "",
    message: "",
    userIds: [],
  });

  const select = {
    value: "selectAll",
    label: "Select All",
  };
  const validationSchema = Yup.object({
    title: Yup.string()
      .max(50, "Heading should have maximum 50 characters")
      .trim()
      .required("Notification Title is required"),
    message: Yup.string()
      .min(10, "Message must be atleast 10 characters.")
      .max(100, "Message must be at most 100 characters.")
      .trim()
      .required("Notification message is required"),
    userIds: Yup.array()
      .min(1, "Atleast one user should be selected")
      .required("Select atleast one user"),
  });

  const showUsers = useCallback(async () => {
    try {
      setLoading(true);
      axios
        .get(`users/getAllUserList`)
        .then((res) => res.data.data)
        .then((data) => {
          // console.log(data.result);
          const user = data.result;
          const userData = user.map((u) => ({
            value: u._id,
            label: `${u.email}`,
          }));
          // console.log([select, ...userData]);
          setCategoryData(userData);
          setOptions([select, ...userData]);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    showUsers();
  }, [showUsers]);

  const handleMultipleSelect = (selectedOptions) => {
    // console.log("selected => ", selectedOptions);
    if (!selectedOptions || selectedOptions.length === 0) {
      formik.setFieldValue("userIds", []); // Clear Formik state
      setUserIds([]); // Clear userIds state
      return;
    }
    selectedOptions.map((s) => {
      if (s.value === "selectAll") {
        // console.log("SelectAll=>", s);
        const ids = categoryData.map((s) => s.value);
        formik.setFieldValue("userIds", ids);
        setUserIds(categoryData);
      } else {
        // console.log("Select Options", s);
        const ids = selectedOptions
          ? selectedOptions.map((option) => option.value)
          : [];
        formik.setFieldValue("userIds", ids); // Update Formik state
        setUserIds(selectedOptions ? selectedOptions : []); // Update userid state if needed
      }
    });

    // Check if "selectAll" is among the selected options
    // const isSelectAll = selectedOptions.some(
    //   (option) => option.value === "selectAll"
    // );

    // if (isSelectAll) {
    //   const ids = categoryData.map((option) => option.value); // Get all ids
    //   formik.setFieldValue("userIds", ids); // Set all ids in Formik
    //   setUserIds(categoryData); // Set the entire categoryData as selected
    // } else {
    //   const ids = selectedOptions.map((option) => option.value);
    //   formik.setFieldValue("userIds", ids); // Update Formik state
    //   setUserIds(selectedOptions); // Update userIds state
    // }
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      // console.log(userid);
      setDisabledSubmit(true);
      try {
        const ids = userid.length
          ? userid.map((option) => option.value)
          : values.userIds;
        const updateData = {
          title: values.title,
          message: values.message,
          userIds: ids,
        };
        // console.log(ids);
        setTitle(values.title);
        setMessage(values.message);
        setUsers(ids);
        // console.log(formData)
        const noti = await axios.patch(
          `/notification/${params.id}`,
          updateData
        );
        // console.log(noti);
        // setLoading(true);
        toast("Notification Sent", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "success",
        });
        setDisabledSubmit(false);
        setTitle("");
        setMessage("");
        setUsers([]);
        resetForm();
        // console.log(users);
      } catch (error) {
        console.log(error);
        setTitle("");
        setMessage("");
        setUsers([]);
        resetForm();
        toast("Could not send notification", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
        });
        setLoading(true);
        setDisabledSubmit(false);
        // console.log(users);
      }
    },
  });

  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const response = await axios.get(
          `admin-website/notification/${params.id}`
        );
        const fetched = response.data.data;
        setData(fetched);
        const fetchedIds = fetched.userId?.map((u) => u._id) || [];
        setUsers(fetchedIds);
        setInitialValues({
          title: fetched.title,
          message: fetched.message,
          userIds: fetchedIds,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchNotification();
  }, []);

  useEffect(() => {
    if (!categoryData.length || !users?.length) return;
    const selected = categoryData.filter((opt) => users.includes(opt.value));
    setUserIds(selected);
    formik.setFieldValue(
      "userIds",
      selected.map((opt) => opt.value)
    );
  }, [categoryData, users]);
  return (
    <div>
      <Helmet>Notification</Helmet>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className=" shadow-primary border-radius-lg pt-4 pb-3"
                >
                  <div className="d-flex ps-3 align-item-center">
                    <i
                      style={{ color: "#fff", cursor: "pointer" }}
                      className="fa fa-arrow-left fs-4"
                      onClick={() => {
                        navigate(-1);
                      }}
                    ></i>
                    <h6 className="text-white text-capitalize ps-4 ">
                      Edit Notification
                    </h6>
                  </div>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Notification Heading</label>

                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="title"
                        name="title"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Notification Heading "
                        value={formik.values.title || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {formik.errors.title ? (
                      <div className="text-danger">{formik.errors.title}</div>
                    ) : null}

                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Notification Message</label>

                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="message"
                        name="message"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Notification Message"
                        value={formik.values.message || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {formik.errors.message ? (
                      <div className="text-danger">{formik.errors.message}</div>
                    ) : null}

                    <div className="input-group input-group-outline mb-3">
                      <label
                        className="fs-5"
                        style={{ marginRight: "20px", padding: "10px 0" }}
                      >
                        Users
                      </label>
                      <div className="dropdown-users" style={{ width: "100%" }}>
                        <Select
                          isMulti
                          name="userIds"
                          options={options}
                          className="basic-multi-select"
                          closeMenuOnSelect={false}
                          maxMenuHeight={300}
                          // values= {formik.values.userIds}
                          // onChange={handleMultipleSelect}
                          value={
                            formik.values.userIds === "selectAll"
                              ? categoryData
                              : formik.values.userIds.map((id) =>
                                  categoryData.find(
                                    (option) => option.value === id
                                  )
                                )
                          }
                          // onChange={(selectedOptions) => {
                          //   const ids = selectedOptions
                          //     ? selectedOptions.map((option) => option.value)
                          //     : [];
                          //   formik.setFieldValue("userIds", ids); // Update Formik state
                          //   setUserIds(selectedOptions ? selectedOptions : []); // Update userid state if needed
                          // }}
                          onChange={handleMultipleSelect}
                        />
                      </div>
                    </div>
                    {formik.errors.userIds ? (
                      <div className="text-danger">{formik.errors.userIds}</div>
                    ) : null}

                    <div className="text-center d-flex justify-content-center gap-4">
                      <button
                        type="submit"
                        className="btn btn-lg  btn-lg w-20 mt-4 mb-0"
                        disabled={disabledSubmit}
                        style={{
                          backgroundColor: "#46456e",
                          color: "#fff",
                        }}
                      >
                        {disabledSubmit ? (
                          <div>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="sr-only"></span> Submitting
                          </div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                      <button
                        type="button"
                        onClick={() => navigate("/sport-category")}
                        className="btn btn-lg  btn-lg w-20 mt-4 mb-0"
                        disabled={disabledSubmit}
                        style={{
                          backgroundColor: "#46456e",
                          color: "#fff",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </div>
  );
}

export default EditNoti;
